
export class CategoryItem {
  public id: number;
  public code: string;
  public name: string;
  public genders: string[];
  public divisions: number[];
  public divisionsLabel: string;
  public playersLabel: string;
  public isPara: boolean;
  public isHistoric: boolean;
  public isMixed: boolean;


  constructor(rawCategoryItem: any) {
    this.id = rawCategoryItem.Id;
    this.code = rawCategoryItem.Code;
    this.name = rawCategoryItem.Name;
    this.genders = rawCategoryItem.Gender;
    this.divisions = rawCategoryItem.DivId;
    this.divisionsLabel = rawCategoryItem.DivisionLabel;
    this.playersLabel = rawCategoryItem.PlayersLabel;
    this.isPara = rawCategoryItem.ParaAr;
    this.isHistoric = rawCategoryItem.His;
    this.isMixed = rawCategoryItem.Mixed;
  }


}